import { atom } from 'recoil'
import { ISelectOption } from './ISelect'

const DelivTypeState = atom<ISelectOption[] | null>({
  key: 'DelivTypeState',
  default: null,
})

export default DelivTypeState
